import config from '@/config';
import useCache from '@/hooks/useCache';
import useGoBack from '@/hooks/useGoBack';
import Loader from '@/shared-components/loader/Loader';   
import ProfileOptionsPageHeader from '@/shared-components/navigation/ProfileOptionsPageHeader';
import Text from '@/shared-components/text/components/Text';

import ReferralLink from './components/ReferralLink';
import VirtualList from './components/VirtualList';

import './index.css';

export default function Referrals() {
  const { loading, fetchData, loadMoreData } = useCache(
    "user_referrals",
    `${config.apis.api.url}/referrals`,
    {
      injectToken: true
    }
  );
  const goBackHandler = useGoBack("/profile");

  return (
    <>
      <div className="referrals__page">
        <div className="referrals__wrapper">
          <ProfileOptionsPageHeader title="Referral system" onBack={goBackHandler} />

          {/* ✅ Loader replacement */}
          {loading ? (
            <Loader />
          ) : (
            <>
              <ReferralLink fetchData={fetchData} />

              <Text className="referrals__text font-size-small" paragraph justify>
                Boost your earnings with Suarte's referral program! Share your unique referral link,
                and earn 1% of the final sale price for every purchase made by users who joined
                through your referral - not just once, but for every purchase they make. This ongoing passive
                income will be reflected in your monthly electronic bill.
              </Text>

              {/* 
              <Text className="referrals__large-text" paragraph justify large>
                Your referral income:{" "} 
                <span>${Utils.numberWithCommas(fetchData.referral_income)}</span>
              </Text>
              */}

              {fetchData.data.length === 0 ? (
                <Text className="referrals__empty-text font-size-small" paragraph>
                  New referrals will be displayed here. Share the link and start receiving passive income.
                </Text>
              ) : (
                <>
                  <Text
                    className="referrals__text font-size-medium"
                    style={{ marginBottom: "12px" }}
                    paragraph
                    justify>
                    You currently have{" "}
                    <span>{fetchData.totalDocs} referrals:</span>
                  </Text>

                  <VirtualList items={fetchData} onLoadMore={loadMoreData} />
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}
